import { InputLabel, Stack } from '@mui/material';
import { Controller, FieldValues } from 'react-hook-form';

import ActiveDays from 'kerberus-components/src/Components/Checkboxes/ActiveDays';

import { BaseInputProps } from './GetFormInput';

export function FormDays<T extends FieldValues>({ control, label, required, value }: Readonly<BaseInputProps<T>>) {
    return (
        <Controller
            control={control}
            name={value}
            render={({ field: { onChange, value } }) => (
                <Stack spacing={2}>
                    <InputLabel sx={{ color: 'black', fontWeight: 'medium', mb: 0.5 }}>{label}</InputLabel>
                    <ActiveDays onChange={onChange} value={value as unknown as number[]} />
                </Stack>
            )}
            rules={{
                required: required ? `${label ?? value} cannot be empty` : false,
            }}
        />
    );
}
